import InputMonetario from "components/input/InputMonetario";
import { Label } from "components/input/Label";
import Viagem from "model/viagem/Viagem";
import ViagemAprovacao from "model/viagem/ViagemAprovacao";
import ViagemDespesaPrevista from "model/viagem/ViagemDespesaPrevista";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import ViagemAprovacaoService from "service/viagem/ViagemAprovacaoService";
import { converterData, converterDataHora } from "utils/convert";

type Props = {
    visible: boolean;
    onHide: () => void;
    idViagem: number;
}

const viagemAprovacaoService = new ViagemAprovacaoService();
export default function ModalViagemAprovacaoVisualizar(props: Props) {
    const [dialogImagensDespesaPrevista, setDialogImagensDespesaPrevista] = useState<{ visible: boolean, despesaPrevista: ViagemDespesaPrevista }>({ visible: false, despesaPrevista: new ViagemDespesaPrevista() });
    const [photoOpen, setPhotoOpen] = useState<boolean>(false);
    const [urlOpened, setUrlOpened] = useState<string>('');

    const [viagem, setViagem] = useState<Viagem | null>(null);
    const [aprovacoesAgrupadas, setAprovacoesAgrupadas] = useState<{ sequencial: number, aprovacoes: ViagemAprovacao[] }[]>([]);


    useEffect(() => {
        if (props.idViagem) {
            viagemAprovacaoService.consultar(props.idViagem).then((data) => {
                setViagem(data);
                const aprovacoesAgrupadasLocal: { sequencial: number, aprovacoes: ViagemAprovacao[] }[] = [];
                data.aprovacoes.forEach(aprovacao => {
                    let agrupamento = aprovacoesAgrupadasLocal.find(agrupamento => agrupamento.sequencial === aprovacao.sequencial);
                    if (!agrupamento) {
                        agrupamento = { sequencial: aprovacao.sequencial, aprovacoes: [aprovacao] };
                        aprovacoesAgrupadasLocal.push(agrupamento);
                    } else {
                        agrupamento.aprovacoes.push(aprovacao);
                    }
                });
                aprovacoesAgrupadasLocal.sort((a, b) => a.sequencial - b.sequencial);
                setAprovacoesAgrupadas(aprovacoesAgrupadasLocal);
            }).catch((err) => {
                console.error(err);
            });
        }
    }, [])
    return (
        <>
            {
                photoOpen && (
                    <Lightbox
                        mainSrc={urlOpened}
                        onCloseRequest={() => setPhotoOpen(false)}
                        reactModalStyle={{ overlay: { zIndex: 102 } }}
                    />
                )
            }
            <Dialog
                header="Visualizar Viagem"
                visible={props.visible}
                baseZIndex={100}
                style={{ width: '80%' }}
                onHide={props.onHide}
                footer={<>
                    <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                </>}
            >

                {dialogImagensDespesaPrevista.visible ? <Dialog baseZIndex={101} header="Imagens" visible={dialogImagensDespesaPrevista.visible} style={{ width: '50vw' }} onHide={() => { setDialogImagensDespesaPrevista({ visible: false, despesaPrevista: new ViagemDespesaPrevista() }) }}>
                    <div style={{ display: "flex" }}>

                        {dialogImagensDespesaPrevista.despesaPrevista.imagens.map((imagem, index) => {
                            return (
                                <div key={index} style={{ display: 'flex', marginTop: 8, overflow: 'auto' }}>
                                    <div key={`img${index}`} style={{ justifyContent: 'center', borderWidth: 1, borderColor: '#dadada', borderStyle: 'solid', marginLeft: 5, display: 'grid' }}>
                                        <a className='p-lightbox-image-target' style={{ marginLeft: 'auto', cursor: 'pointer', marginRight: 'auto', width: 128, textAlign: 'center' }} onClick={() => {
                                            setTimeout(() => {
                                                setPhotoOpen(true)
                                                setUrlOpened(imagem.url)

                                            }, 100)
                                        }}>
                                            <img style={{ maxHeight: 128, maxWidth: 128 }} src={imagem.url} title={imagem.nome} />
                                        </a>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </Dialog> : null
                }


                <div className="row">
                    <Label className="col col-sm-12">Código da Viagem</Label>
                    <div className="col-sm-12" style={{ width: 200 }}>
                        <InputText value={viagem?.codigo || ''} readOnly style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Situação</Label>
                    <div className="col-sm-12">
                        <InputText value={viagemAprovacaoService.getSituacao(viagem?.situacao || "")} readOnly style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Data da solicitação</Label>
                    <div className="col-sm-12" style={{ width: 200 }}>
                        <InputText value={converterDataHora(viagem?.dataSolicitacao as Date | null)} readOnly style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Solicitante</Label>
                    <div className="col-sm-12">
                        <InputText value={viagem?.usuarioSolicitante?.nome} readOnly style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Centro de Custo</Label>
                    <div className="col-sm-12">
                        <InputText value={viagem?.centroCusto?.nome} readOnly style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Itinerário</Label>
                    <div className="col-sm-12">
                        <InputTextarea value={viagem?.itinerario} readOnly style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Motivo da Viagem</Label>
                    <div className="col-sm-12">
                        <InputTextarea value={viagem?.motivoViagem} readOnly style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Acompanhante</Label>
                    <div className="col-sm-12">
                        <InputText value={viagem?.acompanhante} readOnly style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Data de Partida</Label>
                    <div className="col-sm-12" style={{ width: 200 }}>
                        <InputText value={converterData(viagem?.dataPartida as Date | null)} readOnly style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Data de Retorno</Label>
                    <div className="col-sm-12" style={{ width: 200 }}>
                        <InputText value={converterData(viagem?.dataRetorno)} readOnly style={{ width: '100%' }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Tipo de Locomoção</Label>
                    <div className="col-sm-12">
                        <InputText value={viagemAprovacaoService.getTipoLocomocao(viagem?.tipoLocomocao || "")} readOnly style={{ width: '100%' }} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <Checkbox
                            checked={viagem?.reservarPassagem as boolean}
                            readOnly
                            style={{ marginRight: 5 }}
                        />
                        <Label>Reservar passagem</Label>
                    </div>
                </div>
                {viagem?.reservarPassagem ?
                    <div className="row">
                        <Label className="col col-sm-12">Observação da reserva de passagem</Label>
                        <div className="col-sm-12">
                            <InputTextarea value={viagem?.observacaoReservaPassagem} readOnly style={{ width: '100%' }} />
                        </div>
                    </div>
                    : null}

                <div className="row">
                    <div className="col-sm-12">
                        <Checkbox
                            checked={viagem?.reservarHotel as boolean}
                            readOnly
                            style={{ marginRight: 5 }}
                        />
                        <Label>Reservar hotel</Label>
                    </div>
                </div>
                {viagem?.reservarHotel ?
                    <div className="row">
                        <Label className="col col-sm-12">Observação da reserva de hotel</Label>
                        <div className="col-sm-12">
                            <InputTextarea value={viagem?.observacaoReservaHotel} readOnly style={{ width: '100%' }} />
                        </div>
                    </div>
                    : null}

                <div className="row">
                    <Label className="col col-sm-12">Observação da solicitação</Label>
                    <div className="col-sm-12">
                        <InputTextarea value={viagem?.observacaoSolicitacao} readOnly style={{ width: '100%' }} />
                    </div>
                </div>

                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-sm-12">
                        <DataTable value={viagem?.despesasPrevistas} header='Despesas Previstas' emptyMessage="Nenhum registro encontrado">
                            <Column field="tipo.nome" header="Tipo" />
                            <Column field="observacao" header="Observação" />
                            <Column field="valor" header="Valor" body={(rowData) => rowData.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} />
                            <Column header="Imagens" body={(rowData) => rowData.imagens.length > 0 ? <Button icon="pi pi-images" onClick={() => setDialogImagensDespesaPrevista({ visible: true, despesaPrevista: rowData })} /> : ""} />
                        </DataTable>
                    </div>
                </div>

                <div className="row">
                    <Label className="col col-sm-12">Valor do adiantamento</Label>
                    <div className="col-sm-12" style={{ width: 200 }}>
                        <InputMonetario value={viagem?.valorAdiantamento || 0} inputStyle={{ textAlign: 'right' }} readOnly onChange={() => { }} />
                    </div>
                </div>
                <div className="row">
                    <Label className="col col-sm-12">Data do adiantamento</Label>
                    <div className="col-sm-12" style={{ width: 200 }}>
                        <InputText value={converterData(viagem?.dataAdiantamento)} readOnly style={{ width: '100%' }} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <Checkbox
                            checked={viagem?.depositoConta as boolean}
                            readOnly
                            style={{ marginRight: 5 }}
                        />
                        <Label>Depósito em conta</Label>
                    </div>
                </div>
                {viagem?.depositoConta ?
                    <>
                        <div className="row">
                            <Label className="col col-sm-12">Banco depósito</Label>
                            <div className="col-sm-12">
                                <InputTextarea value={viagem.bancoDeposito} readOnly style={{ width: '100%' }} />
                            </div>
                        </div>
                        <div className="row">
                            <Label className="col col-sm-12">Banco depósito</Label>
                            <div className="col-sm-12">
                                <InputTextarea value={viagem.bancoDeposito} readOnly style={{ width: '100%' }} />
                            </div>
                        </div>
                        <div className="row">
                            <Label className="col col-sm-12">Agência depósito</Label>
                            <div className="col-sm-12">
                                <InputTextarea value={viagem.agenciaDeposito} readOnly style={{ width: '100%' }} />
                            </div>
                        </div>
                        <div className="row">
                            <Label className="col col-sm-12">Conta depósito</Label>
                            <div className="col-sm-12">
                                <InputTextarea value={viagem.contaDeposito} readOnly style={{ width: '100%' }} />
                            </div>
                        </div>
                    </>
                    : null}

                <div className="row">
                    <Label className="col col-sm-12">Data do acerto</Label>
                    <div className="col-sm-12" style={{ width: 200 }}>
                        <InputText value={converterData(viagem?.dataAcerto)} readOnly style={{ width: '100%' }} />
                    </div>
                </div>

                <div className="row">
                    <Label className="col col-sm-12 mb-2 mt-2">Aprovações</Label>
                    <Accordion multiple >
                        {aprovacoesAgrupadas.map(grupo => {
                            return <AccordionTab key={grupo.sequencial} header={"Sequencial: " + grupo.sequencial}>
                                <DataTable value={grupo.aprovacoes} header='Aprovações' emptyMessage="Nenhum registro encontrado">
                                    <Column field="usuario.nome" header="Aprovador" />
                                    <Column field="situacao" header="Situação" body={(rowData) => viagemAprovacaoService.getSituacaoAprovacao(rowData.situacao)} />
                                    <Column field="dataAprovacao" header="Data da situação" body={(rowData) => converterData(rowData.dataAprovacao)} />
                                    <Column field="motivo" header="Motivo da rejeição" />
                                </DataTable>
                            </AccordionTab>
                        })}
                    </Accordion>
                </div>

            </Dialog>
        </>
    );
}